
import './App.css';
import Chat from './Components/chat/index';

function App() {
  return (
    <div className="App">
   <Chat/>
    </div>
  );
}

export default App;
